import { useRef, useState } from "react";
import { media } from "../../libs/media";
import Messages from "./translations/OnllineTestimonial.json";
import { useLangContext } from "../../components/translateContext";
import { Icon } from "@iconify/react";
import { Slide } from "react-reveal";
import Wrapper from "../../components/sectionWrapper";

const { moov,mtn,Mastercard,togo , Ivoire } = media.Logos;
export default function OnlineTestimonial() {
  const [isAboutAPI, setIsAboutAPI] = useState(false);
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang],  };




  return (
   <Wrapper
    childrenClassName="relative"
    className="bg-qoswhite pb-10 md:pb-20 z-10 overflow-hidden relative"
  >
     
     <div className="mt-10 relative flex-inline  justify-left align-left w-full">
        <div className="mb-4">
          <p className="text-qosorange md:text-x3l font-semibold">
            {Infos.msg.Customers}
          </p>
        </div>

        <div className="w-full flex-inline  md:w-full gap-4 justify-start ">
          <div className="w-full md:w-6/12 ">
            <span className="md:pt-4 md:text-x4l font-semibold md:w-11/12 lg:w-11/12 xl:11/12 ">
              {Infos.msg.HelloText}
            </span>
          </div>
        </div>

        <div className="w-full flex-inline  md:w-full gap-4 justify-start ">
          <div className="mt-4 w-full md:w-6/12 ">
            <span className="text-qosblackText md:Mobilw24  ">
              {Infos.msg.description}
            </span>
          </div>
        </div>
      </div>

      <div className=" grid md:flex md:w-full  gap-4 mt-14">

        <div className="bg-qoswhite w-full md:w-6/12 py-4">
          <img
            src={media.Logos.Online.CommentOneOne}
            alt=""
            className="h-full w-full  md:h-full md:w-full   "
          />
        </div>
        <div className="bg-qoswhite w-full md:w-6/12 py-4">
          <img
            src={media.Logos.Online.CommentTwoTwo}
            alt=""
            className="h-full w-full  md:h-full md:w-full   "
          />
        </div>
        <div className="bg-qoswhite w-full md:w-6/12 py-4">
          <img
            src={media.Logos.Online.CommentThreeThree}
            alt=""
            className="h-full w-full  md:h-full md:w-full   "
          />
        </div>

       
      </div>
    
    </Wrapper>
  );
}
